module.exports = __webpack_public_path__ + "static/media/Super.06305971.png";